import React, { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { LinkCell } from '../components/LinkCell';
import { TextCell } from '../components/TextCell';
import { DateCell } from '../components/DateCell';
import { MoneyCell } from '../components/MoneyCell';
import { TicketCell } from '../components/TicketCell';
import { useDynamicReducerSelector } from '../store';
import { BooleanCell } from '../components/BooleanCell';
import { CELL_TYPE, CELL_TYPE_MAPPING, GAME_HISTORY_INVISIBLE_FIELDS } from '../constants';

import style from '../GameHistory.scss';

export const renderCell = ({ name, row }) => {
    switch (CELL_TYPE_MAPPING[name]) {
        case CELL_TYPE.DATE:
            return <DateCell name={name} row={row}/>;
        case CELL_TYPE.BOOLEAN:
            return <BooleanCell name={name} row={row}/>;
        case CELL_TYPE.MONEY:
            return <MoneyCell name={name} row={row}/>;
        case CELL_TYPE.LINK:
            return <LinkCell name={name} row={row}/>;
        case CELL_TYPE.TICKET:
            return <TicketCell name={name} row={row}/>;
        default:
            return <TextCell name={name} row={row}/>;
    }
};

export const useTableData = () => {
    const { fields } = useComponentConfig();
    const translate = useComponentTranslations();
    const history = useDynamicReducerSelector(prop('history'));
    const details = fields.filter((item) => !GAME_HISTORY_INVISIBLE_FIELDS.includes(item));

    return useMemo(() => (
        {
            accordionView: {
                rows: history.map(item => ({
                    id: item.code,
                    headerCells: [{
                        id: 0,
                        content: renderCell({ name: 'gameName', row: item }),
                        className: style.gameNameCell
                    }, {
                        id: 1,
                        content: (
                            <>
                                <div className={style.gameName}>
                                    {renderCell({ name: 'win', row: item })}
                                </div>
                                <div className={style.dateTime}>
                                    {renderCell({ name: 'datetime', row: item })}
                                </div>
                            </>
                        ),
                        className: style.smallDetails
                    }],
                    rowCells: details.filter((name) => item[name])
                        .map((name, index) => ({
                            id: index,
                            content: (
                                <div key={name} className={style.detailRow}>
                                    <div className={style.cellName}>
                                        {translate(`table.header.column.${name}`)}
                                    </div>
                                    <div className={style.cellValue}>
                                        {renderCell({ name, row: item })}
                                    </div>
                                </div>
                            )
                        }))
                }))
            }
        }
    ), [history, details, translate]);
};
